import React from 'react';
import { BADGE_CATALOG, getBadgeRarityColor } from '../utils/badgeSystem';

const BadgeGrid = ({ badges, maxDisplay = 6, size = 'medium' }) => {
  const displayBadges = maxDisplay ? badges.slice(0, maxDisplay) : badges;
  
  const sizeClasses = {
    small: {
      container: 'gap-2',
      badge: 'text-2xl',
      wrapper: 'w-12 h-12'
    },
    medium: {
      container: 'gap-3',
      badge: 'text-3xl',
      wrapper: 'w-16 h-16'
    },
    large: {
      container: 'gap-4',
      badge: 'text-4xl',
      wrapper: 'w-20 h-20'
    }
  };

  const classes = sizeClasses[size] || sizeClasses.medium;

  if (!badges || badges.length === 0) {
    return null;
  }

  return (
    <div className={`flex flex-wrap ${classes.container}`}>
      {displayBadges.map((badgeRecord) => {
        const badge = BADGE_CATALOG.find(b => b.id === badgeRecord.badgeId);
        if (!badge) return null;

        return (
          <div
            key={badgeRecord.id}
            className={`${classes.wrapper} rounded-full bg-gradient-to-br ${badge.color} flex items-center justify-center shadow-lg hover:scale-110 transition-transform cursor-pointer relative group`}
            title={`${badge.name}: ${badge.description}`}
          >
            <span className={classes.badge}>{badge.icon}</span>
            
            {/* Tooltip */}
            <div className="absolute bottom-full mb-2 left-1/2 transform -translate-x-1/2 bg-gray-900 text-white text-xs rounded-lg px-3 py-2 whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-10">
              <div className="font-semibold">{badge.name}</div>
              <div className="text-gray-300">{badge.description}</div>
              <div className={`text-xs mt-1 ${getBadgeRarityColor(badge.rarity)}`}>
                {badge.rarity.charAt(0).toUpperCase() + badge.rarity.slice(1)}
              </div>
              {/* Arrow */}
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 -mt-1">
                <div className="border-4 border-transparent border-t-gray-900"></div>
              </div>
            </div>
          </div>
        );
      })}
      
      {maxDisplay && badges.length > maxDisplay && (
        <div
          className={`${classes.wrapper} rounded-full bg-gray-200 flex items-center justify-center text-gray-600 font-bold shadow-lg`}
          title={`+${badges.length - maxDisplay} more badges`}
        >
          <span className={size === 'small' ? 'text-sm' : 'text-base'}>
            +{badges.length - maxDisplay}
          </span>
        </div>
      )}
    </div>
  );
};

export default BadgeGrid;

